import FirestoreCollectionStore from '../../../modules/vuex-firestore/FirestoreCollectionStore'

const state = {}

const mutations = {}

const getters = {}

const actions = {
  saveImage({ state, commit }, { key, value }) {
    state.$collection.doc(key).set({ imageKey: value }, { merge: true }).then(doc => {
      commit('$change', { key: 'imageKey', value })
    })
  }
}

function formatter({
  text = '',
  imageKey = null,
  timestamp,
  order = 0
}) {
  return {
    text,
    imageKey,
    timestamp,
    order
  }
}

export default new FirestoreCollectionStore({
  $name: 'items',
  $formatter: formatter,
  $sortKey: 'order',
  state,
  mutations,
  getters,
  actions
})
